import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialCautionService = {
    list: async (formData) => axios.post(`${API_URL}/material-cautions/search`, formData).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialCautionService;